import React, { useState } from 'react';
import { Rooms, findRoom } from '../common/rooms';

interface RoomProps {
	username: string;
	rooms: Rooms;
	onChoose: (room: string) => void;
	onStart: () => void;
}

function Room({username, rooms, onChoose, onStart}: RoomProps) {
	const room = findRoom(rooms, username)!;
	const roomUserList = room.players.map(user => <li key={user}>{user}</li>);
	const isHost = room.host == username;
	const hostText = (
		isHost
		? "You are hosting this room."
		: `You are waiting in ${room.host}'s room.`
	)
	const isReady = room.players.length >= 2;
	const startButton = !isHost ? <> </> : (
		<button disabled={!isReady} onClick={onStart}>
			✓ &nbsp; Start game
		</button>
	);

	return (
		<div>
		<p> {hostText} </p>
		<ul> {roomUserList} </ul>
		<button onClick={() => { onChoose("") }}>
		✗ &nbsp; Leave room
		</button>
		{startButton}
		</div>
	);
}

interface LobbyProps {
	mode: string;
	username: string;
	rooms: Rooms;
	onChoose: (room: string) => void;
	onStart: () => void;
}

export default function Lobby({mode, username, rooms, onChoose, onStart}: LobbyProps) {
	const room = findRoom(rooms, username);

	if (mode != "lobby")
		return <></>;

	if (room) {
		return (
			<Room
				username={username}
				rooms={rooms}
				onChoose={onChoose}
				onStart={onStart}
			/>
		);
	}

	const roomsList = [...rooms.values()];
	const roomsButtons = roomsList.map(room => {
		if (room.playing)
			return(
				<li key={room.host}>
				{room.host}&apos;s game has already started.
				</li>
			);
		return(
			<li key={room.host}>
			<button onClick={() => onChoose(room.host)}>
			→ &nbsp; Join {room.host}&apos;s game
			</button>
			</li>
		);
	})

	return(<ul>
		<li key="_create">
		<button onClick={() => onChoose(username)}>
		+ &nbsp; Create a new game
		</button>
		</li>
		{roomsButtons}
	</ul>);
}

